@use '@design/components/custom-scroll/custom-scroll' as *;

.container {
  display: flex;
  flex-direction: column;
  width: 600px;
  max-width: 90vw;
  height: 400px;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-soft);
  flex-shrink: 0;
}

.body {
  flex: 1;
  min-height: 0;
  margin-bottom: 20px;
  overflow-y: auto;
  @include custom-scroll-minimal;
}

.wrapper {
  height: 100%;
  width: 100%;
  padding: 20px;
}

.stateContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 20px;
}

.emptyText {
  margin: 0;
  color: var(--text-soft);
}
